<template>
  <div>
    <div class="blocks">
      <div class="mobile-only">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <span class="mod-icon-arrow-left mod-icon-back" @click="$router.back()" />
            <h2 class="ml-2">Discounts</h2>
          </div>
          <div class="flex-grow-1 mr-3">
            <div class="input-group search w-100 ml-3">
              <button type="button" class="btn input-group-btn" @click="clearSearch">
                <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
              </button>
              <input class="form-control" type="text" v-model="q" @keyup="searchText($event)"
                     placeholder="Search"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="desktop-only">
        <div class="d-flex align-items-center justify-content-start">
          <div class="">
            <h1>Discounts</h1>
          </div>
          <div class="input-group search w-25 ml-3">
            <button type="button" class="btn input-group-btn" @click="clearSearch">
              <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
            <input class="form-control" type="text" v-model="q" @keyup="searchText($event)"
                   placeholder="Search"
            />
          </div>
        </div>
      </div>

      <div class="mb-2 mobile-only mt-3">
        <div class="d-flex align-items-center justify-content-between">
          <div class="">
            <p class="text-secondary m-0">
              Discounts for {{ meta.total }} jobs
            </p>
            <span>
              ${{ sums.total_amount }}
            </span>
          </div>
          <div class="d-flex align-items-center mb-1">
            <button class="btn btn-primary btn-schedule btn-refine" @click="showFilters = true">
              <span v-if="!clearFiltersButtonShouldBeDisabled" class="mobile-dot-refine-active-filters" />
              REFINE
            </button>
            <button class="btn btn-secondary expand-all" @click="expanded = !expanded">
              <i :class="[expanded ? 'fa fa-compress' : 'fa fa-expand']" />
            </button>
          </div>
        </div>
      </div>

      <div class="row mb-2 desktop-only">
        <div class="col-11 filters-field">
          <span>Filters:</span>
          <span v-if="filtersLoaded">
            <span v-if="filters.move_date" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('move_date')" />
              Move Date: {{ filters.move_date }}</span>
            <span v-if="filters.carrier.length && carriers">
              <span v-for="carrier in filters.carrier" :key="carrier" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('carrier', carrier)" />
                Carrier: {{ carriers.find(el => el.id === carrier).name }}</span>
            </span>
            <span v-if="filters.type.length && types">
              <span v-for="type in filters.type" :key="type" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('type', type)" />
                Type: {{ types.find(el => el.id === type).name }}</span>
            </span>
            <span v-if="filters.discountUnitTypeId && discountUnitTypes && discountUnitTypes.length">
              <span class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('discountUnitTypeId')" />
                Unit: {{ discountUnitTypes.find(el => el.id === filters.discountUnitTypeId).name }}
              </span>
            </span>
          </span>
          <button type="button" class="btn btn-secondary add-filters" @click="showFilters = true">
            <i class="fa fa-plus filter-icon" />
          </button>
        </div>
        <div class="col-1 d-flex justify-content-end">
          <div class="dropdown">
            <button class="btn btn-secondary sort-button sort-button-selected" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false"
            >
              <i v-if="selectedKey.length" class="fa pr-2"
                 :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']"
              />
              <span v-if="selectedKey === 'move_date'">
                Move date
              </span>
              <span v-else>
                Sort by
              </span>
              <i class="fa fa-caret-down caret" />
            </button>
            <div class="dropdown-menu sort-dropdown dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item sort-dropdown-item nav-link btn" @click.stop="sortBy('move_date')">
                <span :class="[selectedKey === 'move_date' ? 'selected' : '']">
                  Move date
                </span>
                <span>
                  <i v-if="selectedKey === 'move_date'" class="fa"
                     :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']"
                  />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="loading">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else-if="!discounts.length">
      <div class="desktop-only">
        <span>There are no results.</span>
      </div>
      <div class="mobile-only text-center mb-3">
        <span>There are no results.</span>
      </div>
    </template>
    <template v-else>
      <div class="desktop-only">
        <DiscountsHeader />
        <DiscountsStatistics class="blocks" :meta="meta"
                             :sums="sums"
        />

        <div class="blocks">
          <DiscountsBlock
            v-for="(discount, index) in discounts" :key="index" :discount="discount" :discount-types="types"
            @update="filter"
          />
        </div>
        <div class="row blocks">
          <div class="col-sm-6 mb-1 text-black-50 pl-0"
               v-if="meta.total"
          >
            Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
          </div>
          <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
        </div>
      </div>

      <div class="mobile-only">
        <div class="list-jobs container-fluid m-0 mt-3">
          <div class="row">
            <div class="col-3" />
            <div class="col-3 text-center">
              <span class="total-table-title">Description</span>
            </div>
            <div class="col-3 text-center">
              <span class="total-table-title">Amount</span>
            </div>
            <div class="col-3 text-center">
              <span class="total-table-title">Type</span>
            </div>
          </div>
        </div>

        <DiscountsBlockMobile v-for="discount in discounts" :discount="discount" :key="discount.id" :expanded-all="expanded" />

        <div class="row blocks">
          <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
        </div>
      </div>
    </template>

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters
              button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move date</label>
                      <flat-pickr v-model="filters.move_date"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Move Date"
                                  name="date"
                                  @on-close="onMoveDateChange"
                      />
                      <span class="position-absolute clear-date" @click="clearMoveDateAndSearch"
                            v-if="filters.move_date"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent"
                            v-else
                      ><span class="mod-icon-rates-dark" /></span>
                    </div>
                  </div>
                  <div class="col-12" v-if="carriers && carriers.length">
                    <div class="select-wrap">
                      <label>Carriers</label>
                      <key-multiselect v-model="filters.carrier"
                                       :options="carriers"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :hide-selected="true"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="types && types.length">
                    <div class="select-wrap">
                      <label>Type</label>
                      <key-multiselect v-model="filters.type"
                                       :options="types"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="discountUnitTypes && discountUnitTypes.length">
                    <div class="select-wrap">
                      <label>Unit</label>
                      <simple-select v-model="filters.discountUnitTypeId"
                                     :hide-deselect="true"
                                     :options="discountUnitTypes"
                                     label="name"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from 'axios';
import Pagination from '../Pagination';
import DiscountsHeader from './DiscountsHeader';
import DiscountsBlock from './DiscountsBlock';
import DiscountsStatistics from './DiscountsStatistics';
import DiscountsBlockMobile from './DiscountsBlockMobile';

export default {
  name: 'Discounts',
  components: {
    DiscountsBlockMobile,
    DiscountsBlock,
    DiscountsHeader,
    DiscountsStatistics,
    flatPickr,
    Pagination,
  },
  data: () => ({
    averages: [],
    config: {
      dateFormat: 'm/j/Y',
      mode: 'range',
    },
    discounts: [],
    exporting: false,
    filters: {
      carrier: [],
      moveDateEnd: '',
      moveDateStart: '',
      move_date: '',
      sortKey: '',
      sortOrders: '',
      type: [],
      discountUnitTypeId: '',
    },
    selectedKey: '',
    meta: [],
    page: 1,
    q: '',
    cancelToken: '',
    source: '',
    urlQuery: '',
    inProgress: false,
    showFilters: false,
    loading: false,
    types: [],
    sums: [],
    expanded: false,
  }),
  computed: {
    ...mapState({
      filtersLoaded: state => state.guard.filtersLoaded,
      carriers: state => state.carriers.carriers.data,
      discountUnitTypes: state => state.values.discountUnitTypes,
    }),
    ascOrDesc() {
      return this.filters.sortOrders === 'asc' ? 'asc' : 'desc';
    },
    clearFiltersButtonShouldBeDisabled() {
      return !this.filters.move_date && !this.filters.carrier.length && !this.filters.type.length;
    },
  },
  created() {
    this.cancelToken = axios.CancelToken;
    this.source = this.cancelToken.source();
  },
  mounted() {
    this.getTypes();
    if (Object.keys(this.$route.query).length !== 0) {
      this.setFilters(this.$route.query);
    }
    this.filter();
  },
  methods: {
    changePage(pageNum) {
      this.page = pageNum;
      this.filter();
    },
    getTypes() {
      axios.get('/values/job-discount-types').then(res => {
        this.types = res.data.data;
      });
    },
    setFilters(query) {
      this.filters = Object.assign(
        {
          carrier: query.carrier_id ? query.carrier_id.split(',').map(i => Number(i)) : [],
          moveDateStart: query.date_from ? query.date_from.toString() : '',
          moveDateEnd: query.date_to ? query.date_to.toString() : '',
          move_date:
            query.date_from && query.date_to
              ? `${query.date_from.toString()} to ${query.date_to.toString()}`
              : '',
          sortKey: query.sort,
          sortOrders: query.order,
          type: query.type_id ? query.type_id.split(',').map(i => Number(i)) : [],
          discountUnitTypeId: query.discount_unit_type_id
            ? parseInt(query.discount_unit_type_id, 10)
            : '',
        },
        {},
      );
      this.q = query.q.toString();
      this.page = query.page;
      this.selectedKey = this.filters.sortKey;
    },
    getDiscountsFiltered(query) {
      this.loading = true;
      this.inProgress = true;
      axios
        .get(`/jobs/discounts?${query}`, { cancelToken: this.source.token })
        .then(res => {
          this.discounts = res.data.data;
          this.sums = res.data.sums;
          this.meta = res.data.meta;
        })
        .finally(() => {
          this.loading = false;
          this.inProgress = false;
        })
        .catch(err => {
          if (axios.isCancel(err)) {
            this.loading = false;
          }
        });
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    filter() {
      const query =
        `page=${this.page}&date_from=${this.filters.moveDateStart}` +
        `&carrier_id=${this.filters.carrier}` +
        `&type_id=${this.filters.type}` +
        `&date_to=${this.filters.moveDateEnd}&q=${encodeURIComponent(this.q)}` +
        `&sort=${this.filters.sortKey}&order=${this.filters.sortOrders}` +
        `&discount_unit_type_id=${this.filters.discountUnitTypeId}`;
      this.urlQuery = query;
      if (!this.inProgress) {
        this.getDiscountsFiltered(query);
        if (this.$_checkProperties(this.filters)) {
          this.$router.push(`/reports/discounts?${query}`);
        } else {
          this.$router.push(`/reports/discounts`);
        }
      } else {
        // If there is a request in progress, cancel it, and try again with other request
        this.source.cancel('Operation canceled by the user.');
        // Set axios cancel token and source to new values, so you can repeat request
        this.cancelToken = axios.CancelToken;
        this.source = this.cancelToken.source();
        this.inProgress = false;
        this.getDiscountsFiltered(query);
        if (this.$_checkProperties(this.filters)) {
          this.$router.push(`/reports/discounts?${query}`);
        } else {
          this.$router.push(`/reports/discounts`);
        }
      }
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          carrier: [],
          move_date: '',
          moveDateStart: '',
          moveDateEnd: '',
          sortKey: '',
          sortOrders: '',
          type: [],
        },
        {},
      );
      this.filter();
      this.showFilters = false;
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    clearMoveDateAndSearch() {
      this.filters.move_date = '';
      this.filters.moveDateStart = '';
      this.filters.moveDateEnd = '';
      this.page = 1;
      this.filter();
    },
    onMoveDateChange(selectedDates) {
      this.filters.moveDateStart = selectedDates[0]
        ? selectedDates[0].toLocaleDateString('en-US')
        : '';
      this.filters.moveDateEnd = selectedDates[1]
        ? selectedDates[1].toLocaleDateString('en-US')
        : '';
      this.search();
    },
    sortBy(key) {
      this.selectedKey = key;
      this.$set(this.filters, 'sortKey', key);
      this.$set(this.filters, 'sortOrders', this.filters.sortOrders === 'desc' ? 'asc' : 'desc');
      this.filter();
    },
    removeFilter(model, id) {
      if (id) {
        this.filters[model] = this.filters[model].filter(element => element !== id);
      } else {
        this.filters[model] = '';
      }
      if (model === 'move_date') {
        this.filters.move_date = '';
        this.filters.moveDateStart = '';
        this.filters.moveDateEnd = '';
      }
      this.search();
    },
  },
};
</script>
<style lang="scss" scoped>
.totals-wrapper {
  height: calc(80vh - 172px);
  overflow: auto;
}

.input-group {
  width: 35%;
}

.total-table-title {
  white-space: nowrap;
  font-size: 0.67rem;
  font-weight: 500;
  color: black;
  text-align: right;
}

.mobile-only {
  display: none;
}

@media screen and (max-width: 600px) {
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none;
  }

  .new-bg {
    height: 80vh !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reports/Discounts.vue